export enum LoginSignupFormType {
  phoneNumber = "phoneNumber",
  firstName = "firstName",
  lastName = "lastName",
  vuaId = "vuaId",
  email = "email",
  pin = "pin",
}
